import { ENABLE_LOGGING } from "../_game/config/Game";
import { EventClass, EventType } from "../_game/config/Events";
import { IS_MOBILE, __EventDispatcher, __LocalStorage, __Mobile, __ProxiProvider, __UrlParams } from "./core";
import { AVAILABLE_RESOLUTIONS }  from '../_core/config/config.App'
 
interface HTMLEventsInterface {
  onRezize?: (_payload: any) => void;
  onVisibilityChanged?: (_payload: any) => void;
}

export default class HTMLEvents {

  private FULLSCREEN: boolean = false;
  private FOCUS: boolean = false;
  public MUTE_BEFORE: boolean = false;

  public onResize: (_payload: any) => void;
  public onVisibilityChanged: Function;

	public isONLINE: boolean = true;

  constructor(_props: HTMLEventsInterface) {
 
    this.onResize = _props.onRezize as any;
    this.onVisibilityChanged = _props.onVisibilityChanged as any; 
  
    this.initFullScreenEvents();

    if (window.addEventListener) {
      window.addEventListener('mousewheel', this.onScroll, false);
      window.addEventListener('DOMMouseScroll', this.onScroll, false);
    }

    document.addEventListener('visibilitychange', this.initVisibilityChanged.bind(this));
    window.addEventListener('resize', this.onResizeEvent.bind(this));
    window.addEventListener('keyup', this.onKeyUp.bind(this));
    window.addEventListener('keydown', this.onKeyDown.bind(this));
    window.addEventListener('click', this.onClick.bind(this));
    window.addEventListener('touchend', this.onClick.bind(this));
    window.addEventListener('online', this.onOnline.bind(this));
    window.addEventListener('offline', this.onOffline.bind(this));

    this.LOG("HTML Plugin Events:: Init");
  }
  
  get fullscreen() {
    return this.FULLSCREEN;
  }

  get focus() {
    return this.FOCUS;
  }
   
  private initVisibilityChanged(_event: any) {

    if (document.visibilityState === 'hidden') {
      this.onBlur();
    } else {
      this.onFocus();
    }

    this.LOG("On Visibility Changed Event: " + this.focus);
  }

  private initFullScreenEvents() {

		document.addEventListener('fullscreenchange', this.onFullScreenChanged.bind(this));
    document.addEventListener('mozfullscreenchange', this.onFullScreenChanged.bind(this));
    document.addEventListener('webkitfullscreenchange', this.onFullScreenChanged.bind(this));
    document.addEventListener('msfullscreenchange', this.onFullScreenChanged.bind(this));
  }

  onOnline(e: any) {
    __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.ONLINE);
		this.isONLINE = true;
    this.LOG("Application is online");
  }

  onOffline(e: any) {
    __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.OFFLINE);
		this.isONLINE = false;
    this.LOG("Application is offline");
  }
 
  onKeyDown(e: any) {
    let nCode = e.keyCode || e.charCode;
    __EventDispatcher.dispatch(EventClass.INPUT, EventType.INPUT.KEY_PRESSED, { keyCode: nCode });
  };
  
  onKeyUp(e: any) {
    let nCode = e.keyCode || e.charCode;
    __EventDispatcher.dispatch(EventClass.INPUT, EventType.INPUT.KEY_RELEASED, { keyCode: nCode });
  };

  onClick() {
    if (window.location.hostname !== 'localhost') {
      if (IS_MOBILE && !__Mobile.isIpad()) {
        this.goFullScreen();
      }
    }
    
    __EventDispatcher.dispatch(EventClass.INPUT, EventType.INPUT.CLICK, {});
  }

  onBlur() {
    this.MUTE_BEFORE = __LocalStorage.isGlobalMuted();
    this.FOCUS = false;
    
    __ProxiProvider.gameExit();
    __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.FOCUS_CHANGED, { bFocused: this.focus });
  } 

  onFocus() {
    this.FOCUS = true;
    __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.FOCUS_CHANGED, { bFocused: this.focus });
  }

  onScroll(e: any) {
    e = window.event || e;
    var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
  
    __EventDispatcher.dispatch(EventClass.INPUT, EventType.INPUT.SCROLL, { delta });
  }

  onFullScreenChanged(e: any) {
		
    // const doc = window.document as any;
    const docEl = document as any;
  
    const fs = docEl.fullscreenElement || docEl.msFullscreenElement || docEl.mozFullScreen || docEl.webkitIsFullScreen;
    this.FULLSCREEN = fs;
  
    //call onResize 
    this.onResizeEvent();
    this.LOG("On Fullscreen Changed Event: " + this.FULLSCREEN);
  };

  goFullScreen() {
		if(__UrlParams.props.siteID === 30) return;
    try {
      if(!this.fullscreen) {
        const doc = window.document as any;
        const docEl = doc.documentElement as any;

        const requestFullScreen =
          docEl.requestFullscreen ||
          docEl.mozRequestFullScreen ||
          docEl.webkitRequestFullScreen ||
          docEl.msRequestFullscreen;
        const cancelFullScreen =
          doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

        if (
          !doc.fullscreenElement &&
          !doc.mozFullScreenElement &&
          !doc.webkitFullscreenElement &&
          !doc.msFullscreenElement
        ) {
          requestFullScreen.call(docEl);
        } else {
          cancelFullScreen.call(doc);
        }
      } 
    } catch(e) {}
  }

  onResizeEvent() {
    let IS_MOBILE = false;
    let LANDSCAPE = false;
 
    if (/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      setTimeout(() => {
        LANDSCAPE = __Mobile.checkLandscape(); 
        IS_MOBILE = __Mobile.checkMobile();

        let resizeObj = {
          bLandscape: LANDSCAPE,
          lMobile: IS_MOBILE,
        };
  
        this.onResize(resizeObj);
        __ProxiProvider.sendWindowSize(window.innerWidth, window.innerHeight);

        let RESOLUTION = "DESKTOP";
        let RESOLUTIONS: any = AVAILABLE_RESOLUTIONS;
 
        for(let i in RESOLUTIONS) {
          if(window.innerWidth <= RESOLUTIONS[i].width) {
            RESOLUTION = i; 
          }
        }
         
        __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.CANVAS_RESIZED, {
          bLandscape: LANDSCAPE,
          bResolution: RESOLUTION,
        });
 
        this.LOG("On Canvas Resize Event: " + JSON.stringify(resizeObj));
      }, 100);
    } else {
      LANDSCAPE = __Mobile.checkLandscape(); 
      IS_MOBILE = __Mobile.checkMobile();

      let resizeObj = {
        bLandscape: LANDSCAPE,
        lMobile: IS_MOBILE,
      };

      this.onResize(resizeObj);
      __ProxiProvider.sendWindowSize(window.innerWidth, window.innerHeight);

      let RESOLUTION = 'DESKTOP';
      let RESOLUTIONS: any = AVAILABLE_RESOLUTIONS;
      for(let i in RESOLUTIONS) {
        if(window.innerWidth <= RESOLUTIONS[i].width) {
          RESOLUTION = i; 
        }
      }
  
      __EventDispatcher.dispatch(EventClass.SYSTEM, EventType.SYSTEM.CANVAS_RESIZED, {
        bLandscape: LANDSCAPE,
        bResolution: RESOLUTION,
      });
  
      this.LOG("On Canvas Resize Event: " + JSON.stringify(resizeObj));
    }

    window.scrollBy(1, -1000);
  }

  LOG(_message: string) {
    if(! ENABLE_LOGGING) return;

    console.groupCollapsed(
      '%c HTML EVENTS                ',
      'background: #479aff; color: white; display: block;',
    );

    console.log(_message);
		console.groupEnd();
  }
}